module.exports = __webpack_public_path__ + "static/media/slider_img3.6c06d376.jpg";